import styled from '@emotion/styled';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import {
  A,
  BOLD,
  LI,
  P,
  UL,
  IMG,
  TABLE,
  TH,
  TBODY,
  TR,
  TD,
  THEAD,
} from './Renderers';

type Props = {
  data: string[][];
};

const renderers = {
  paragraph: P,
  heading: BOLD,
  link: A,
  list: UL,
  listItem: LI,
  image: IMG,
};

export const Table = ({ data }: Props) => {
  const [tableHeaders, ...tableBodyContents] = data;

  return (
    <TableWrapper>
      <TABLE>
        <THEAD>
          <tr>
            {tableHeaders.map((tableHeader) => (
              <TH key={tableHeader}>
                {tableHeader ? (
                  <ReactMarkdown source={tableHeader} renderers={renderers} />
                ) : (
                  <p>&nbsp;</p>
                )}
              </TH>
            ))}
          </tr>
        </THEAD>
        <TBODY>
          {tableBodyContents.map((tableBodyCell, columnIndex) => (
            <TR key={columnIndex}>
              {tableBodyCell.map((cell, index) => (
                <TD
                  key={index}
                  columnIndex={index}
                  content={tableHeaders[index]}
                >
                  {cell ? (
                    <ReactMarkdown source={cell} renderers={renderers} />
                  ) : (
                    <p>&nbsp;</p>
                  )}
                </TD>
              ))}
            </TR>
          ))}
        </TBODY>
      </TABLE>
    </TableWrapper>
  );
};

const TableWrapper = styled.div`
  overflow: auto;
`;
